import { Analytics } from "./AnalyticsGeneral";
import { apiService } from "@/_services";
import { sum, values } from "d3";
import { formatDate_YMD, timeParseNoNull2 } from "@/_core/_helpers/_helpers";

export class AnalyticsCommodity extends Analytics {
  constructor(params) {
    super({ ...params });
  }

  parseManagementData(data, _this, calculate = true) {
    let dateFieldsManagement = [
      "contract_month",
      "contract_month_hedge",
      "date",
      "fixation_date",
      "trade_date",
      "fixing_date",
      "monthDate",
    ];
    let dateFieldsExpo = [
      "created_at",
      "date",
      "date_required",
      "eta",
      "fixation_date",
      "loading_date",
      "p_date",
      "purchase_date",
      "sale_date",
      "shipping_date",
      "updated_at",
    ];
    let dateFieldsHedge = [
      "asian_fixing_start_date",
      "created_at",
      "fixing_date",
      "hedged_date",
      "premium_value_date",
      "sale_date",
      "selected_contract",
      "trade_date",
      "updated_at",
      "value_date",
    ];
    let dateFieldsMerged = [
      "asian_fixing_start_date",
      "created_at",
      "date",
      "eta",
      "fixation_date",
      "fixing_date",
      "hedged_date",
      "p_date",
      "premium_value_date",
      "purchase_date",
      "sale_date",
      "shipping_date",
      "trade_date",
      "updated_at",
      "value_date",
    ];
    // parse expo
    data[0].expo = this.processDataRawExpo(data[0].expo, dateFieldsExpo);
    // parse hedge
    data[0].hedge = this.processDataRawHedge(data[0].hedge, dateFieldsHedge);
    // parse strategies
    data[0].strategies.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse date
    data[0].date.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse date_2
    data[0].date_2.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse contracts
    data[0].contracts.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse clients
    data[0].clients.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    // parse suppliers
    data[0].suppliers.forEach(function(d) {
      for (let i = 0; i < dateFieldsManagement.length; i++) {
        d[dateFieldsManagement[i]] = timeParseNoNull2(
          d[dateFieldsManagement[i]],
        );
      }
      d.q_min_max = `${Math.round(+d.q_min)?.toLocaleString("en-US") ??
        "N/A"} | ${Math.round(+d.q_max)?.toLocaleString("en-US") ?? "N/A"}`;
    });
    Object.assign(_this.Analytics["rawData"], {
      expoPast: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      expoFuture: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      hedgesPast: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      hedgesFuture: [],
    });
    Object.assign(_this.Analytics["rawData"], {
      expo: data[0].expo,
    });
    Object.assign(_this.Analytics["rawData"], {
      hedges: data[0].hedge,
    });
    Object.assign(_this.Analytics["management"], {
      strategies: data[0].strategies,
      date: data[0].date,
      date_2: data[0].date_2,
      contracts: data[0].contracts,
      clients: data[0].clients,
      suppliers: data[0].suppliers,
    });
    // parse merged
    if (
      Object.keys(data[0].mergedExpoHedges).length === 0 ||
      data[0].mergedExpoHedges.length === 0
    ) {
      this.resetData();
    } else {
      let mergedExpoHedges = this.processMergedData(
        data[0].mergedExpoHedges,
        dateFieldsMerged,
      );
      Object.assign(this.rawData, {
        zoomedData: [],
        mergedExpoHedges: mergedExpoHedges,
        dDowns: this.analyticsManager.createDDowns([
          { details: mergedExpoHedges },
        ]),
        dataFilters: this.analyticsManager.defineFilters(this.customFilters),
        filteredData: mergedExpoHedges,
      });
      this.nestAndZoom(mergedExpoHedges, calculate);
    }
  }

  postAnalyticsCommodityUpdate(_this, data, expo) {
    Object.assign(_this.Analytics["loading"], {
      management: true,
      strategies: true,
    });
    let params = {
      method: "POST",
      endpoint: "analytics_commodity_update",
      content_type: "application/json",
      query_params: {
        format: "json",
        derivatives: JSON.stringify(data),
        expo: JSON.stringify(expo),
      },
    };
    return apiService
      .getAll(params)
      .then((response) => {
        this.parseManagementData(response, _this, false);
        Object.assign(_this.Analytics["loading"], {
          management: false,
          strategies: false,
        });
      })
      .catch(function(error) {
        Object.assign(_this.Analytics["loading"], {
          smanagement: false,
          strategies: false,
        });
        console.error(error);
      });
  }

  getManagementData(
    _this,
    initialDate = null,
    selectedCompanies,
    selectedAsset,
    selectedPortfolios,
  ) {
    initialDate = initialDate != null ? initialDate : new Date();
    Object.assign(this.loading, {
      budget: true,
      expo: true,
      hedges: true,
      management: true,
      pastCalcs: true,
      program: true,
      strategies: true,
      derivatives: true,
      topographyCalcs: true,
    });
    this.resetData();
    Object.assign(this.management, {
      strategies: [],
      contracts: [],
      date: [],
      date_2: [],
      clients: [],
      suppliers: [],
    });
    const companies = selectedCompanies.map((d) => d.pk_idcompany);
    const endProducts = selectedAsset.map((d) => d.pk_id_end_product);
    const portfoliosIds = selectedPortfolios.map((d) => d.pk);
    if (
      companies.length == 0 ||
      endProducts.length == 0 ||
      portfoliosIds.length == 0
    ) {
      Object.assign(_this.Analytics["loading"], {
        budget: false,
        expo: false,
        hedges: false,
        management: false,
        pastCalcs: false,
        portCalcs: false,
        program: false,
        strategies: false,
        derivatives: false,
        topographyCalcs: false,
        topographyCalcsRates: false,
      });
      return;
    }
    let params = {
      method: "POST",
      endpoint: "analytics_commodity_manage",
      content_type: "application/json",
      query_params: {
        companies: {
          id_companies: companies,
        },
        date: formatDate_YMD(initialDate),
        end_product: {
          id_assets: endProducts,
        },
        format: "json",
        portfolios: {
          id_portfolios: portfoliosIds,
        },
      },
    };
    apiService
      .getAll(params)
      .then((data) => {
        this.parseManagementData(data, _this);

        Object.assign(_this.Analytics["loading"], {
          budget: false,
          expo: false,
          hedges: false,
          management: false,
          pastCalcs: false, // portCalcs: true,
          program: false, // strategies: true, derivatives: true, topographyCalcs: true, topographyCalcsRates: true
        });
        Object.assign(_this.Analytics["rawData"], { toBeFetched: false });
        Object.assign(_this.Analytics["rawData"], { toBeFetchedHidden: true });
        _this.selectionStr();
      })
      .catch(function(error) {
        Object.assign(_this.Analytics["loading"], {
          budget: false,
          expo: false,
          hedges: false,
          management: false,
          pastCalcs: false,
          portCalcs: false,
          program: false,
          strategies: false,
          derivatives: false,
          topographyCalcs: false,
          topographyCalcsRates: false,
        });
        console.error("getManagementData", error);
      });
  }

  stringTitle() {
    const _this = this;
    let txt = this.analyticsHelpers.selectionStrFct(
      _this["userSelections"]["selectedCompanies"],
      "company_name",
      " companies",
    );
    if (_this["rawData"]["dataFilters"] !== undefined) {
      // == portfolios
      if (_this["rawData"]["dataFilters"]["portfolio"]["value"] != null) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            _this["rawData"]["dataFilters"]["portfolio"]["value"],
            null,
            " portfolios",
          );
      } else {
        if (_this["userSelections"]["selectedPortfolios"] != null) {
          txt +=
            " | " +
            this.analyticsHelpers.selectionStrFct(
              _this["userSelections"]["selectedPortfolios"],
              "name",
              " portfolios",
            );
        }
      }
      // == products
      if (
        _this["rawData"]["dataFilters"]["fk_id_end_product"]["value"] != null
      ) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            _this["rawData"]["dataFilters"]["fk_id_end_product"]["value"],
            null,
            " products",
          );
      } else {
        if (_this["userSelections"]["selectedAsset"] != null) {
          txt +=
            " | " +
            this.analyticsHelpers.selectionStrFct(
              _this["userSelections"]["selectedAsset"],
              "product_name",
              " products",
            );
        }
      }
      // == country
      if (
        _this["rawData"]["dataFilters"]["country_of_destination"]["value"] !=
        null
      ) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            _this["rawData"]["dataFilters"]["country_of_destination"]["value"],
            null,
            " countries",
          );
      } else {
        if (_this["rawData"]["dDowns"]["countryDDown"].length > 0) {
          txt +=
            " | " +
            this.analyticsHelpers.selectionStrFct(
              _this["rawData"]["dDowns"]["countryDDown"],
              null,
              " countries",
            );
        }
      }
      // == business
      if (_this["rawData"]["dataFilters"]["business"]["value"] != null) {
        txt +=
          " | " +
          this.analyticsHelpers.selectionStrFct(
            _this["rawData"]["dataFilters"]["business"]["value"],
            null,
            " business",
          );
      } else {
        if (_this["rawData"]["dDowns"]["businessDDown"].length > 0) {
          txt +=
            " | " +
            this.analyticsHelpers.selectionStrFct(
              _this["rawData"]["dDowns"]["businessDDown"],
              null,
              " business",
            );
        }
      }
    }
    return txt;
  }

  nestingQuantities(v, sign) {
    const isFixationDerivative = this.analyticsHelpers.isFixationDerivative;
    // ==== QUANTITIES  ==== ==== ==== ==== ==== ==== ==== ==== ====
    const m2m_fixedValue = sum(v, function(d) {
      return isFixationDerivative(d.derivative) ? d.hedge_value : 0;
    });
    const m2m_fixedHedgedValue = sum(v, function(d) {
      return d.hedge_value;
    });
    const m2m_hedgeValue = m2m_fixedHedgedValue - m2m_fixedValue;
    let q_budget =
      sign *
      sum(v, function(d) {
        return d.budget_expo;
      });
    const q_commited =
      sign *
      sum(v, function(d) {
        return d.balance;
      });
    const q_forecast =
      sign *
      sum(v, function(d) {
        return d.cash_flow;
      });
    const q_program =
      sign *
      sum(v, function(d) {
        return d.program ? d.program : 0;
      });

    const q_fixed =
      sign *
      sum(v, function(d) {
        return isFixationDerivative(d.derivative)
          ? d.hedgeNotional / d.ratio / d.unit_change
          : 0;
      });
    const q_fixedHedged =
      sign *
      sum(v, function(d) {
        return d.hedgeNotional / d.ratio / d.unit_change;
      });
    const q_hedged =
      sign *
      sum(v, function(d) {
        return d.derivative && !isFixationDerivative(d.derivative)
          ? d.hedgeNotional / d.ratio / d.unit_change
          : 0;
      });

    const q_fixedFut =
      sign *
      sum(v, function(d) {
        return d.derivative && isFixationDerivative(d.derivative)
          ? d.hedgeNotional
          : 0;
      });
    const q_fixedHedgedFut =
      sign *
      sum(v, function(d) {
        return d.derivative ? d.hedgeNotional : 0;
      });
    const q_hedgedFut = q_fixedHedgedFut - q_fixedFut;

    // q_budget = q_budget === 0 ? q_forecast : q_budget;
    return {
      m2m_fixedHedgedValue,
      m2m_fixedValue,
      m2m_hedgeValue,
      q_budget,
      q_commited,
      q_fixed,
      q_fixedFut,
      q_fixedHedged,
      q_fixedHedgedFut,
      q_forecast,
      q_hedged,
      q_hedgedFut,
      q_program,
    };
  }

  nestingBudget(v, sign, q_forecast) {
    let p_budget_au =
      (sign *
        sum(v, function(d) {
          return d.cash_flow !== 0 ? d.budget_price * d.cash_flow : 0;
        })) /
      q_forecast;
    const p_budgetBasis =
      (sign *
        sum(v, function(d) {
          return d.cash_flow !== 0 ? d.base * d.cash_flow : 0;
        })) /
      q_forecast;
    const p_budgetFut =
      (sign *
        sum(v, function(d) {
          return d.cash_flow !== 0 ? d.budget_futures * d.cash_flow : 0;
        })) /
      q_forecast;
    const p_budgetRatio =
      (sign *
        sum(v, function(d) {
          return d.cash_flow !== 0 ? d.ratio * d.price_change * d.cash_flow : 0;
        })) /
      q_forecast;
    p_budget_au =
      Number.isFinite(p_budget_au) && p_budget_au !== 0
        ? p_budget_au
        : this.averageIgnoringNaN(v.map((d) => d.budget_price));
    p_budget_au = p_budget_au === 0 ? NaN : p_budget_au;
    const p_budgetOther =
      p_budget_au - (p_budgetFut * p_budgetRatio + p_budgetBasis);

    return {
      p_budget_au,
      p_budgetBasis,
      p_budgetFut,
      p_budgetOther,
      p_budgetRatio,
    };
  }

  nestingMarket(v, sign, q_forecast, mktRef) {
    let p_market = NaN,
      p_marketBasis = NaN,
      p_marketFut = NaN,
      p_marketOther = NaN,
      p_marketRatio = NaN;

    if (q_forecast !== 0) {
      p_market =
        (sign *
          sum(v, function(d) {
            return d.cash_flow !== 0
              ? (d[mktRef] * d.mkt_ratio * d.price_change + d.mkt_basis) *
                  d.cash_flow
              : 0;
          })) /
        q_forecast;

      p_marketBasis =
        (sign *
          sum(v, function(d) {
            return d.cash_flow !== 0 ? d.mkt_basis * d.cash_flow : 0;
          })) /
        q_forecast;

      p_marketFut =
        (sign *
          sum(v, function(d) {
            return d.cash_flow !== 0 ? d[mktRef] * d.cash_flow : 0;
          })) /
        q_forecast;

      p_marketRatio =
        (sign *
          sum(v, function(d) {
            return d.cash_flow !== 0
              ? d.mkt_ratio * d.price_change * d.cash_flow
              : 0;
          })) /
        q_forecast;

      p_marketOther = p_market - (p_marketFut * p_marketRatio + p_marketBasis);
    }
    return {
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketOther,
      p_marketRatio,
    };
  }

  nestingHedges(
    v,
    sign,
    q_commited,
    q_fixed,
    q_hedged,
    q_fixedHedged,
    q_fixedFut,
    q_hedgedFut,
    q_fixedHedgedFut,
    mktRef,
  ) {
    const isFixationDerivative = this.analyticsHelpers.isFixationDerivative;
    // all variables included: ratio, basis, local costs
    const p_fixed =
      (sign *
        (sum(v, function(d) {
          return isFixationDerivative(d.derivative)
            ? ((1 + d.tariffs) *
                (d.price_change * d.fwd * d.ratio + d.base + d.freight) +
                d.local_costs) *
                (d.hedgeNotional / d.ratio / d.unit_change)
            : 0;
        }) +
          sum(v, function(d) {
            return isFixationDerivative(d.derivative)
              ? +d.hedge_value * (1 + d.tariffs)
              : 0;
          }))) /
      q_fixed;
    const p_hedged =
      (sign *
        (sum(v, function(d) {
          return !isFixationDerivative(d.derivative)
            ? ((1 + d.tariffs) *
                (d.price_change * d.fwd * d.ratio + d.base + d.freight) +
                d.local_costs) *
                (d.hedgeNotional / d.ratio / d.unit_change)
            : 0;
        }) +
          sum(v, function(d) {
            return !isFixationDerivative(d.derivative)
              ? +d.hedge_value * (1 + d.tariffs)
              : 0;
          }))) /
      q_hedged;
    const p_fixedHedged =
      (sign *
        (sum(v, function(d) {
          return (
            ((1 + d.tariffs) *
              (d.price_change * d.fwd * d.ratio + d.base + d.freight) +
              d.local_costs) *
            (d.hedgeNotional / d.ratio / d.unit_change)
          );
        }) +
          sum(v, function(d) {
            return +d.hedge_value * (1 + d.tariffs);
          }))) /
      q_fixedHedged;

    // only futures
    const p_fixedFut =
      q_fixedFut == 0
        ? NaN
        : (sign *
            (sum(v, function(d) {
              return isFixationDerivative(d.derivative)
                ? d.fwd * d.hedgeNotional
                : 0;
            }) +
              sum(v, function(d) {
                return isFixationDerivative(d.derivative)
                  ? d.hedge_value / d.is_cents
                  : 0;
              }))) /
          q_fixedFut;
    const p_hedgedFut =
      q_hedgedFut == 0
        ? NaN
        : (sign *
            (sum(v, function(d) {
              return !isFixationDerivative(d.derivative)
                ? d.fwd * d.hedgeNotional
                : 0;
            }) +
              sum(v, function(d) {
                return !isFixationDerivative(d.derivative)
                  ? d.hedge_value / d.is_cents
                  : 0;
              }))) /
          q_hedgedFut;
    const p_fixedHedgedFut =
      q_fixedHedgedFut == 0
        ? NaN
        : (sign *
            (sum(v, function(d) {
              return d.derivative ? d.fwd * d.hedgeNotional : 0;
            }) +
              sum(v, function(d) {
                return d.hedge_value / d.is_cents;
              }))) /
          q_fixedHedgedFut;

    const p_fixedHedgedBasis =
      q_fixedHedgedFut == 0
        ? NaN
        : (sign *
            sum(v, function(d) {
              return d.fwd_hedge ? d.base * d.hedgeNotional : 0;
            })) /
          q_fixedHedgedFut;

    const p_fixedHedgedRatio =
      q_fixedHedgedFut == 0
        ? NaN
        : (sign *
            sum(v, function(d) {
              return d.fwd_hedge
                ? d.ratio * d.price_change * d.hedgeNotional
                : 0;
            })) /
          q_fixedHedgedFut;

    const p_fixedHedgedOther =
      p_fixedHedged -
      (p_fixedHedgedFut * p_fixedHedgedRatio + p_fixedHedgedBasis);

    // commited quantities
    const p_commited =
      q_commited == 0
        ? NaN
        : q_fixedHedged >= q_commited
        ? p_fixedHedged
        : (sign *
            (sum(v, function(d) {
              return d.balance === 0
                ? 0
                : d.derivative == null
                ? ((1 + d.tariffs) *
                    (d.price_change * d[mktRef] * d.ratio +
                      d.base +
                      d.freight) +
                    d.local_costs) *
                  d.balance
                : ((1 + d.tariffs) *
                    (d.price_change * d.fwd * d.ratio + d.base + d.freight) +
                    d.local_costs) *
                  d.balance;
            }) +
              sum(v, function(d) {
                return +d.hedge_value * (1 + d.tariffs);
              }))) /
          q_commited;

    const q_commitedFut =
      sign *
      sum(v, function(d) {
        return d.balance * d.unit_change * d.ratio;
      });
    const p_comm_aux =
      (sign *
        sum(v, function(d) {
          return d[mktRef] * d.balance * d.unit_change * d.ratio;
        })) /
      q_commitedFut;

    const p_commitedFut =
      q_commited == 0
        ? NaN
        : q_fixedHedgedFut >= q_commitedFut
        ? p_fixedHedgedFut
        : (q_fixedHedgedFut * p_fixedHedgedFut +
            (q_commitedFut - q_fixedHedgedFut) * p_comm_aux) /
          q_commitedFut;

    const p_commitedBasis =
      q_commited == 0
        ? NaN
        : (sign *
            sum(v, function(d) {
              return d.balance === 0 ? 0 : d.base * d.balance;
            })) /
          q_commited;

    const p_commitedRatio =
      q_commited == 0
        ? NaN
        : (sign *
            sum(v, function(d) {
              return d.ratio * d.price_change * d.balance;
            })) /
          q_commited;

    const p_commitedOther =
      p_commited - (p_commitedFut * p_commitedRatio + p_commitedBasis);

    return {
      p_commited,
      p_commitedFut,
      p_commitedBasis,
      p_commitedOther,
      p_commitedRatio,
      p_fixed,
      p_fixedFut,
      p_hedged,
      p_hedgedFut,
      p_fixedHedged,
      p_fixedHedgedFut,
      p_fixedHedgedBasis,
      p_fixedHedgedOther,
      p_fixedHedgedRatio,
    };
  }

  nestingNet(
    m2m_fixedHedgedValue,
    p_commited,
    p_commitedFut,
    p_fixedHedged,
    p_fixedHedgedBasis,
    p_fixedHedgedFut,
    p_fixedHedgedRatio,
    p_market,
    p_marketBasis,
    p_marketFut,
    p_marketRatio,
    q_commited,
    q_fixedHedged,
    q_forecast,
    sign,
  ) {
    let weiAve = this.analyticsHelpers.weiAve;
    let p_net;
    if (
      m2m_fixedHedgedValue !== 0 &&
      Number.isNaN(p_fixedHedged) &&
      Number.isNaN(p_commited)
    ) {
      p_net =
        (p_market * q_forecast + sign * m2m_fixedHedgedValue) / q_forecast;
    } else {
      p_net =
        q_commited >= q_forecast
          ? p_commited
          : q_commited < q_fixedHedged
          ? weiAve(p_fixedHedged, q_fixedHedged, p_market, q_forecast)
          : weiAve(p_commited, q_commited, p_market, q_forecast);
    }
    p_net = Number.isFinite(p_net) ? p_net : p_market;

    let p_netBasis =
      q_commited >= q_forecast
        ? p_fixedHedgedBasis
        : weiAve(p_fixedHedgedBasis, q_commited, p_marketBasis, q_forecast);
    p_netBasis = Number.isFinite(p_netBasis) ? p_netBasis : p_marketBasis;
    let p_netFut =
      q_commited >= q_forecast
        ? p_commitedFut
        : q_commited <= q_fixedHedged
        ? weiAve(p_fixedHedgedFut, q_fixedHedged, p_marketFut, q_forecast)
        : weiAve(p_commitedFut, q_commited, p_marketFut, q_forecast);
    p_netFut = Number.isFinite(p_netFut) ? p_netFut : p_marketFut;

    const p_netRatio = p_fixedHedgedRatio
      ? q_commited >= q_forecast
        ? p_fixedHedgedRatio
        : weiAve(p_fixedHedgedRatio, q_commited, p_marketRatio, q_forecast)
      : p_marketRatio;

    const p_netOther = p_net - (p_netFut * p_netRatio + p_netBasis);

    return { p_net, p_netBasis, p_netFut, p_netOther, p_netRatio };
  }

  nestingDifferences(
    p_budget,
    p_budgetBasis,
    p_budgetFut,
    p_budgetRatio,
    p_fixedHedgedBasis,
    p_fixedHedgedFut,
    p_fixedHedgedRatio,
    p_market,
    p_marketBasis,
    p_marketFut,
    p_marketRatio,
    p_net,
    q_commited,
    q_fixedHedged,
    q_fixedHedgedFut,
    q_forecast,
    sign,
    v,
  ) {
    // Total Values ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 1st diff: Net vs Market
    const v_netVsMkt =
      sign *
      (p_net - p_market) *
      Math.max(q_commited, q_fixedHedged, q_forecast);
    const v_netVsMktFut =
      sign *
      v[0].is_cents *
      (p_fixedHedgedFut - p_marketFut) *
      q_fixedHedgedFut;
    const v_netVsMktBasis =
      sign * (p_fixedHedgedBasis - p_marketBasis) * q_commited;
    const v_netVsMktRatio =
      sign * (p_fixedHedgedRatio - p_marketRatio) * q_commited * p_marketFut;

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 2nd diff: hedge P&L
    const v_fixedHedged = sum(v, function(d) {
      return d.hedge_value;
    });

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 3rd diff: Open Exposure:
    // For ratio: market ratio - bought/sold ratio × market futures price × unhedged quantity.
    // For basis/premium: market basis - bought/sold basis × unhedged quantity.
    const v_exposedRatio =
      (p_marketRatio - p_fixedHedgedRatio) *
      p_marketFut *
      Math.max(0, q_commited - q_fixedHedged);
    const v_exposedBasis =
      (p_marketBasis - p_fixedHedgedBasis) *
      Math.max(0, q_commited - q_fixedHedged);

    // ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // 4th diff: Net – Budget
    const v_budget =
      sign *
      (p_net - p_budget) *
      Math.max(q_commited, q_fixedHedged, q_forecast); // All
    const v_budgetFixedHedgedFut =
      sign *
      v[0].is_cents *
      (p_fixedHedgedFut - p_budgetFut) *
      q_fixedHedgedFut; // Futures
    const v_budgetBasis =
      sign * (p_fixedHedgedBasis - p_budgetBasis) * q_commited; // Basis
    const v_budgetRatio =
      sign * (p_fixedHedgedRatio - p_budgetRatio) * q_commited * p_budgetFut; // Ratio

    return {
      v_netVsMkt,
      v_netVsMktFut,
      v_netVsMktBasis,
      v_netVsMktRatio,
      v_fixedHedged,
      v_exposedRatio,
      v_exposedBasis,
      v_budget,
      v_budgetFixedHedgedFut,
      v_budgetBasis,
      v_budgetRatio,
    };
  }

  nestingChangeQty(
    q_budget,
    q_commited,
    q_fixed,
    q_fixedHedged,
    q_forecast,
    q_hedged,
    q_program,
  ) {
    const q_budgetPerc = q_budget / q_forecast;
    const q_commitedPerc = q_commited / q_forecast;
    const q_commitedPercS = q_commited / q_forecast;
    const q_programPerc = q_program / q_forecast;
    const q_fixedPerc = q_fixed / q_forecast;
    const q_fixedPercS = q_fixed / q_forecast;
    const q_hedgedPerc = q_hedged / q_forecast;
    const q_fixedHedgedPerc = q_fixedHedged / q_forecast;

    return {
      q_budgetPerc,
      q_commitedPerc,
      q_commitedPercS,
      q_fixedHedgedPerc,
      q_fixedPerc,
      q_fixedPercS,
      q_hedgedPerc,
      q_programPerc,
    };
  }

  nestingChangePr(
    p_budget,
    p_budgetBasis,
    p_budgetFut,
    p_budgetRatio,
    p_commited,
    p_fixed,
    p_fixedHedged,
    p_fixedHedgedFut,
    p_fixedHedgedRatio,
    p_hedged,
    p_market,
    p_marketBasis,
    p_marketFut,
    p_marketRatio,
    p_net,
    p_netBasis,
    p_netFut,
    p_netRatio,
  ) {
    // ==== BASIS ==== ==== ==== ==== ==== ==== ==== ====
    const p_fixedHedgedBasisPerc = p_fixedHedged / p_budgetBasis - 1;
    const p_marketBasisPerc = p_marketBasis / p_budgetBasis - 1;
    const p_netBasisPerc = p_netBasis / p_budgetBasis - 1;
    // ==== RATIOS ==== ==== ==== ==== ==== ==== ==== ====
    const p_fixedHedgedRatioPerc = p_fixedHedgedRatio / p_budgetRatio - 1;
    const p_marketRatioPerc = p_marketRatio / p_budgetRatio - 1;
    const p_netRatioPerc = p_netRatio / p_budgetRatio - 1;
    // ==== FUTURES ==== ==== ==== ==== ==== ==== ==== ====
    const p_fixedHedgedFutPerc = p_fixedHedgedFut / p_budgetFut - 1;
    const p_marketFutPerc = p_marketFut / p_budgetFut - 1;
    const p_netFutPerc = p_netFut / p_budgetFut - 1;
    // ==== PRICES ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const p_fixedPerc = p_fixed / p_budget - 1;
    const p_fixedHedgedPerc = p_fixedHedged / p_budget - 1;
    const p_commitedPerc = p_commited / p_budget - 1;
    const p_hedgedPerc = p_hedged / p_budget - 1;
    const p_marketPerc = p_market / p_budget - 1;
    const p_netPerc = p_net / p_budget - 1;

    return {
      p_commitedPerc,
      p_fixedHedgedBasisPerc,
      p_fixedHedgedFutPerc,
      p_fixedHedgedPerc,
      p_fixedHedgedRatioPerc,
      p_fixedPerc,
      p_hedgedPerc,
      p_marketBasisPerc,
      p_marketFutPerc,
      p_marketPerc,
      p_marketRatioPerc,
      p_netBasisPerc,
      p_netFutPerc,
      p_netPerc,
      p_netRatioPerc,
    };
  }

  /** processes a set of data to calculate quantities, normalized percentages, prices, etc. */
  nestingMainCalcs(v, intervalGroup, data, sign) {
    const date = this.analyticsHelpers.timeComparison(
      values(v).pop().date,
      intervalGroup,
      data,
    );
    // exportToCSV(v, 'data_to_nest.csv')
    // ==== QUANTITIES  ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      m2m_fixedHedgedValue,
      m2m_fixedValue,
      m2m_hedgeValue,
      q_budget,
      q_commited,
      q_fixed,
      q_fixedFut,
      q_fixedHedged,
      q_fixedHedgedFut,
      q_forecast,
      q_hedged,
      q_hedgedFut,
      q_program,
    } = this.nestingQuantities(v, sign);

    // ==== BUDGET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      p_budget_au,
      p_budgetBasis,
      p_budgetFut,
      p_budgetOther,
      p_budgetRatio,
    } = this.nestingBudget(v, sign, q_forecast);
    let p_budget = +p_budget_au;

    // MARKET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const mktRef =
      this.userSelections.mktRef === "spot"
        ? "fwd"
        : this.userSelections.mktRef === "1W"
        ? "settle_ma_5"
        : this.userSelections.mktRef === "2W"
        ? "settle_ma_10"
        : this.userSelections.mktRef === "1M"
        ? "settle_ma_20"
        : "fwd";
    const {
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketOther,
      p_marketRatio,
    } = this.nestingMarket(v, sign, q_forecast, mktRef);
    // p_budget = Number.isFinite(p_budget) ? p_budget : p_market;

    // FIXED & HEDGED prices ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      p_commited,
      p_commitedFut,
      p_commitedBasis,
      p_commitedOther,
      p_commitedRatio,
      p_fixed,
      p_fixedFut,
      p_hedged,
      p_hedgedFut,
      p_fixedHedged,
      p_fixedHedgedFut,
      p_fixedHedgedBasis,
      p_fixedHedgedOther,
      p_fixedHedgedRatio,
    } = this.nestingHedges(
      v,
      sign,
      q_commited,
      q_fixed,
      q_hedged,
      q_fixedHedged,
      q_fixedFut,
      q_hedgedFut,
      q_fixedHedgedFut,
      mktRef,
    );

    // NET ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      p_net,
      p_netBasis,
      p_netFut,
      p_netOther,
      p_netRatio,
    } = this.nestingNet(
      m2m_fixedHedgedValue,
      p_commited,
      p_commitedFut,
      p_fixedHedged,
      p_fixedHedgedBasis,
      p_fixedHedgedFut,
      p_fixedHedgedRatio,
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketRatio,
      q_commited,
      q_fixedHedged,
      q_forecast,
      sign,
    );

    // Total Values ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    const {
      v_netVsMkt,
      v_netVsMktFut,
      v_netVsMktBasis,
      v_netVsMktRatio,
      v_fixedHedged,
      v_exposedRatio,
      v_exposedBasis,
      v_budget,
      v_budgetFixedHedgedFut,
      v_budgetBasis,
      v_budgetRatio,
    } = this.nestingDifferences(
      p_budget,
      p_budgetBasis,
      p_budgetFut,
      p_budgetRatio,
      p_fixedHedgedBasis,
      p_fixedHedgedFut,
      p_fixedHedgedRatio,
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketRatio,
      p_net,
      q_commited,
      q_fixedHedged,
      q_fixedHedgedFut,
      q_forecast,
      sign,
      v,
    );

    // CHANGES ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ==== ====
    // ==== QUANTITIES ==== ==== ==== ==== ==== ==== ==== ====
    const {
      q_budgetPerc,
      q_commitedPerc,
      q_commitedPercS,
      q_fixedHedgedPerc,
      q_fixedPerc,
      q_fixedPercS,
      q_hedgedPerc,
      q_programPerc,
    } = this.nestingChangeQty(
      q_budget,
      q_commited,
      q_fixed,
      q_fixedHedged,
      q_forecast,
      q_hedged,
      q_program,
    );
    // ==== PRICES ==== ==== ==== ==== ==== ==== ==== ====
    const {
      p_commitedPerc,
      p_fixedHedgedBasisPerc,
      p_fixedHedgedFutPerc,
      p_fixedHedgedPerc,
      p_fixedHedgedRatioPerc,
      p_fixedPerc,
      p_hedgedPerc,
      p_marketBasisPerc,
      p_marketFutPerc,
      p_marketPerc,
      p_marketRatioPerc,
      p_netBasisPerc,
      p_netFutPerc,
      p_netPerc,
      p_netRatioPerc,
    } = this.nestingChangePr(
      p_budget,
      p_budgetBasis,
      p_budgetFut,
      p_budgetRatio,
      p_commited,
      p_fixed,
      p_fixedHedged,
      p_fixedHedgedFut,
      p_fixedHedgedRatio,
      p_hedged,
      p_market,
      p_marketBasis,
      p_marketFut,
      p_marketRatio,
      p_net,
      p_netBasis,
      p_netFut,
      p_netRatio,
    );
    return {
      date: date,
      m2m_fixedHedgedValue: m2m_fixedHedgedValue,
      m2m_fixedValue: m2m_fixedValue,
      m2m_hedgeValue: m2m_hedgeValue,
      p_budget: p_budget,
      p_budgetBasis: p_budgetBasis,
      p_budgetFut: p_budgetFut,
      p_budgetOther: p_budgetOther,
      p_budgetRatio: p_budgetRatio,
      p_commited: p_commited,
      p_commitedFut: p_commitedFut,
      p_commitedBasis: p_commitedBasis,
      p_commitedOther: p_commitedOther,
      p_commitedRatio: p_commitedRatio,
      p_commitedPerc: p_commitedPerc,
      p_fixed: p_fixed,
      p_fixedFut: p_fixedFut,
      p_fixedHedged: p_fixedHedged,
      p_fixedHedgedBasis: p_fixedHedgedBasis,
      p_fixedHedgedBasisPerc: p_fixedHedgedBasisPerc,
      p_fixedHedgedFut: p_fixedHedgedFut,
      p_fixedHedgedFutPerc: p_fixedHedgedFutPerc,
      p_fixedHedgedOther: p_fixedHedgedOther,
      p_fixedHedgedPerc: p_fixedHedgedPerc,
      p_fixedHedgedRatio: p_fixedHedgedRatio,
      p_fixedHedgedRatioPerc: p_fixedHedgedRatioPerc,
      p_fixedPerc: p_fixedPerc,
      p_hedged: p_hedged,
      p_hedgedFut: p_hedgedFut,
      p_hedgedPerc: p_hedgedPerc,
      p_market: p_market,
      p_marketBasis: p_marketBasis,
      p_marketBasisPerc: p_marketBasisPerc,
      p_marketFut: p_marketFut,
      p_marketFutPerc: p_marketFutPerc,
      p_marketOther: p_marketOther,
      p_marketPerc: p_marketPerc,
      p_marketRatio: p_marketRatio,
      p_marketRatioPerc: p_marketRatioPerc,
      p_net: p_net,
      p_netBasis: p_netBasis,
      p_netBasisPerc: p_netBasisPerc,
      p_netFut: p_netFut,
      p_netFutPerc: p_netFutPerc,
      p_netOther: p_netOther,
      p_netPerc: p_netPerc,
      p_netRatio: p_netRatio,
      p_netRatioPerc: p_netRatioPerc,
      q_budget: q_budget,
      q_budgetPerc: q_budgetPerc,
      q_commited: q_commited,
      q_commitedPerc: q_commitedPerc,
      q_commitedPercS: q_commitedPercS,
      q_fixed: q_fixed,
      q_fixedFut: q_fixedFut,
      q_fixedHedged: q_fixedHedged,
      q_fixedHedgedFut: q_fixedHedgedFut,
      q_fixedHedgedPerc: q_fixedHedgedPerc,
      q_fixedPerc: q_fixedPerc,
      q_fixedPercS: q_fixedPercS,
      q_forecast: q_forecast,
      q_hedged: q_hedged,
      q_hedgedFut: q_hedgedFut,
      q_hedgedPerc: q_hedgedPerc,
      q_program: q_program,
      q_programPerc: q_programPerc,
      v_budget: v_budget,
      v_budgetBasis: v_budgetBasis,
      v_budgetFixedHedgedFut: v_budgetFixedHedgedFut,
      v_budgetRatio: v_budgetRatio,
      v_exposedBasis: v_exposedBasis,
      v_exposedRatio: v_exposedRatio,
      v_fixedHedged: v_fixedHedged,
      v_netVsMkt: v_netVsMkt,
      v_netVsMktBasis: v_netVsMktBasis,
      v_netVsMktFut: v_netVsMktFut,
      v_netVsMktRatio: v_netVsMktRatio,
      zeroFld: 0,
    };
  }
}

export const managementFields = [
  {
    id: 0,
    dataType: "",
    field: "contract_month_year",
    header: "Fut. Contract",
    styles: { "max-width": "6rem" },
  },
  {
    id: 1,
    dataType: "",
    field: "custom_name",
    header: "ID",
    styles: { width: "5rem" },
  },
  {
    id: 2,
    dataType: "date",
    field: "date",
    header: "Date",
    styles: { width: "6rem" },
  },
  {
    id: 3,
    dataType: "",
    field: "end_product_str",
    header: "Product",
    styles: { width: "9rem" },
  },
  {
    id: 4,
    dataType: "number",
    field: "cash_flow_ch",
    header: "Req. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 5,
    dataType: "",
    field: "supplier",
    header: "Supplier",
    styles: { width: "5rem" },
  },
  {
    id: 6,
    dataType: "",
    field: "client_str",
    header: "Client",
    styles: { width: "9rem" },
  },
  {
    id: 7,
    dataType: "",
    field: "business",
    header: "Business",
    styles: { width: "5rem" },
  },
  {
    id: 8,
    dataType: "",
    field: "fk_id_plant",
    header: "Plant",
    styles: { width: "5rem" },
  },
  {
    id: 9,
    dataType: "",
    field: "fk_id_port",
    header: "Port",
    styles: { width: "5rem" },
  },
  {
    id: 10,
    dataType: "number",
    field: "hedgeNotional_ch",
    header: "Hedged. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 11,
    dataType: "priceNone",
    field: "base",
    header: "Basis",
    styles: { "max-width": "5rem" },
  },
  {
    id: 12,
    dataType: "priceNone",
    field: "ratio",
    header: "Ratio",
    styles: { "max-width": "5rem" },
  },
  {
    id: 13,
    dataType: "",
    field: "contract_month_year_hedge",
    header: "Future",
    styles: { width: "5rem" },
  },
  {
    id: 14,
    dataType: "",
    field: "strategy_name",
    header: "Strategy",
    styles: { width: "10rem" },
  },
  {
    id: 15,
    dataType: "",
    field: "counterparty",
    header: "Counterparty",
    styles: { width: "7rem" },
  },
  {
    id: 16,
    dataType: "",
    field: "buy_sell",
    header: "Position",
    styles: { "max-width": "5rem" },
  },
  {
    id: 17,
    dataType: "",
    field: "derivative",
    header: "Derivative",
    styles: { width: "5rem" },
  },
  {
    id: 18,
    dataType: "number",
    field: "hedge_value",
    header: "Mark 2 Mkt",
    styles: { width: "7rem" },
  },
  {
    id: 19,
    dataType: "number",
    field: "delta_ch",
    header: "Delta Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 20,
    dataType: "priceNone",
    field: "spot",
    header: "Mkt Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 21,
    dataType: "price",
    field: "strategy_value",
    header: "Strategy Value",
    styles: { width: "6rem" },
  },
  {
    id: 22,
    dataType: "price",
    field: "strike",
    header: "Strike",
    styles: { "max-width": "6rem" },
  },
  {
    id: 23,
    dataType: "date",
    field: "trade_date",
    header: "Trade Date",
    styles: { "max-width": "6rem" },
  },
  {
    id: 24,
    dataType: "",
    field: "weighted_strikes",
    header: "Details",
    styles: { width: "12rem" },
  },
  {
    id: 25,
    dataType: "number",
    field: "quantity_hedge",
    header: "Strat. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 26,
    dataType: "",
    field: "strategy_w_code",
    header: "Strategy",
    styles: { width: "5rem" },
  },
  {
    id: 27,
    dataType: "",
    field: "custom_id",
    header: "Expo ID",
    styles: { width: "8rem" },
  },
  {
    id: 28,
    dataType: "number",
    field: "expoQ",
    header: "-No- Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 29,
    dataType: "futDate",
    field: "monthDate",
    header: "Shipping Month",
    styles: { "max-width": "5rem" },
  },
  {
    id: 30,
    dataType: "",
    field: "show",
    header: "Show",
    styles: { width: "5rem" },
  },
  {
    id: 31,
    dataType: "",
    field: "status",
    header: "Status",
    styles: { "max-width": "6rem" },
  },
  {
    id: 32,
    dataType: "date",
    field: "fixing_date",
    header: "Fixing Date",
    styles: { "max-width": "6rem" },
  },
  {
    id: 33,
    dataType: "number",
    field: "balance_ch",
    header: "Locked Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 34,
    dataType: "",
    field: "q_min_max",
    header: "Min | Max Q",
    styles: { "max-width": "7rem" },
  },
  {
    id: 35,
    dataType: "number",
    field: "q_current_ch",
    header: "Accum. Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 36,
    dataType: "priceNone",
    field: "strategy_strike",
    header: "Strat. Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 37,
    dataType: "date",
    field: "fixation_date",
    header: "Last Fixation Date",
    styles: { "max-width": "7rem" },
  },
  {
    id: 38,
    dataType: "priceNone",
    field: "budget_futures",
    header: "Ref. Price",
    styles: { "max-width": "6rem" },
  },
  {
    id: 39,
    dataType: "",
    field: "commodity",
    header: "Cmdty Expo",
    styles: { width: "6rem" },
  },
  {
    id: 39,
    dataType: "",
    field: "commodity_hedge",
    header: "Cmdty Hedge",
    styles: { width: "6rem" },
  },
  {
    id: 40,
    dataType: "priceNone",
    field: "bonus",
    header: "Exch. Rate",
    styles: { width: "6rem" },
  },
  {
    id: 41,
    dataType: "number",
    field: "m2m_fx",
    header: "M2Mkt Exch.",
    styles: { width: "7rem" },
  },
  {
    id: 42,
    dataType: "number",
    field: "gamma_ch",
    header: "Gamma Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 43,
    dataType: "number",
    field: "theta_ch",
    header: "Theta Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 44,
    dataType: "number",
    field: "vega_ch",
    header: "Vega Q",
    styles: { "max-width": "5rem" },
  },
  {
    id: 45,
    dataType: "number",
    field: "rho_ch",
    header: "Rho Q",
    styles: { "max-width": "5rem" },
  },
];
